<section class="flex h-full min-h-0 w-full flex-col gap-y-4">
  <!-- Sub-navigation between the three screens -->
  <nav aria-label="Spark Ads sections" class="flex shrink-0 flex-row items-center gap-x-2">
    @for (item of navItems; track item.view) {
      <button
        type="button"
        (click)="selectView(item.view)"
        [attr.aria-current]="store.view() === item.view ? 'page' : null"
        class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-colors"
        [class]="getNavClass(item.view)"
      >
        {{ item.label }}
      </button>
    }
  </nav>

  <div class="min-h-0 flex-1 overflow-y-auto scrollbar-transparent">
    @if (briefId(); as brief) {
      @switch (store.view()) {
        @case ('dashboard') {
          <sa-ads-dashboard [briefId]="brief" />
        }
        @case ('videos') {
          <sa-creator-videos [briefId]="brief" />
        }
        @case ('new') {
          <sa-spark-ads-builder [briefId]="brief" />
        }
      }
    }
  </div>
</section>

<!-- Plain-English glossary, opened from any "What does this mean?" link -->
<sa-glossary-drawer />
